// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"d9e432f8","453":"a28ec6f9","748":"825cadee","762":"8546c002"}[chunkId] + ".chunk.js";
};